<div class="plate-container">
  <label class="labelTitle" for="matricula">{{ 'PREVIEW_SPACE.NUMBER_PLATE' | translate }}</label>
  <input #matricula class="input" (change)="emitValueChange(specificData)" [(ngModel)]="matriculaVehiculo"/>
</div>